import { useEffect } from "react";
const Review = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div
    className="elfsight-app-8e20ea5f-3e59-43c4-ad63-c907becf4a0e"
    data-elfsight-app-lazy=""
  />
            </div>
        </section>;
};
export default Review;
